// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

const EInvoicingLogsController = function($scope, $routeParams, PUtill, EInvoicingDispatchStatusDisplayService, EInvoicingLogs, DatepickerUtils) {

    $scope.status = '';
    $scope.statusName = PUtill.getText('Status');
    $scope.dateRange = { dateFrom: null, dateTo: null };

    $scope.updateFilter = function (func) {
        $scope.documents = $scope.paginator(function (options, callback) {
            return EInvoicingLogs.query(options, function () {
                callback();
                if (func)
                    func();
                func = null;
            });
        }, getSearchParams(), 20);
    };

    const getSearchParams = function () {
        if ($scope.dateRange.dateTo)
            $scope.dateRange.dateTo.setDate($scope.dateRange.dateTo.getDate() + 1);
        
        const searchParams = {
            search: $scope.search,
            dateFrom: $scope.dateRange.dateFrom,
            dateTo: $scope.dateRange.dateTo
        };

        if ($scope.status)
            searchParams.status = $scope.status;

        return searchParams;
    };

    function init() {
        if($routeParams.filter) {
            $scope.search = $routeParams.filter;
        }
        if (!$scope.search) {
            $scope.search = "";
        }
        $scope.updateFilter();
    }

    $scope.statusClass = function (status) {
        return PUtill.getStatusClass(status);
    };

    $scope.dispatchStatusClass = EInvoicingDispatchStatusDisplayService.dispatchStatusClass;

    $scope.dispatchStatusLabel = EInvoicingDispatchStatusDisplayService.dispatchStatusLabel;
    
    $scope.dispatchStatusLastPolledAt = EInvoicingDispatchStatusDisplayService.dispatchStatusLastPolledAt;

    $scope.setStatus = function (status, defaultLabelName) {
        $scope.status = status.replaceAll(' ', '');
        $scope.statusName = PUtill.getText(defaultLabelName || status);
        $scope.updateFilter();
    };

    init();
};

EInvoicingLogsController.$inject = ['$scope', '$routeParams', 'PUtill', 'EInvoicingDispatchStatusDisplayService',
    'EInvoicingLogs', 'DatepickerUtils'];
